import { Button, Col, Row, Result, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyEmailApi } from "../../config/Api";
import { readAuthCookie } from "../../config/CookieScript";
import { apiErrorMessage } from "../../services/ApiError";
import { setStoredUserVerified } from "../../services/EmailVerified";
import "./style/ForgetPassword.scss";

// opened from the verification email: /verify-email?token=...
export const VerifyEmail = () => {
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token') || ''
    const [state, setState] = useState(token ? 'loading' : 'error')
    const [message, setMessage] = useState('This verification link is invalid. Please open the link from the email again.')
    // patients don't log in here, so they get no login link
    const [type, setType] = useState(null)
    const isLoggedIn = Boolean(readAuthCookie('auth_token'))

    // a link works once, so make sure it's only sent once (React strict mode runs effects twice)
    const sent = useRef(false)

    useEffect(() => {
        if (!token || sent.current) return
        sent.current = true

        verifyEmailApi(token)
            .then((res) => {
                // the logged-in user verifying their own email can go straight into the app
                if (isLoggedIn && res.data.type === 'user') {
                    setStoredUserVerified(true)
                }
                setType(res.data.type)
                setMessage(res.data.message)
                setState('success')
            })
            .catch((err) => {
                setMessage(apiErrorMessage(err))
                setState('error')
            })
    }, [token, isLoggedIn])

    return (
        <div className="ForgetPassword">
            <div className="ForgetPasswordForm">
                <div className="logoSection">
                    <h2 className="mb-0">Nutri Nexus</h2>
                </div>
                <Row justify="center">
                    <Col xs={24} md={16} xl={11} xxl={{ span: 7 }} className="rightForm">
                        <div id="ForgotPasswordFormContent" className="p-4 rounded">
                            {state === 'loading' && (
                                <div className="text-center p-5">
                                    <Spin />
                                    <p className="mt-3">Verifying your email…</p>
                                </div>
                            )}
                            {state === 'success' && (
                                <Result
                                    status="success"
                                    title="Email verified"
                                    subTitle={message}
                                    extra={type === 'patient'
                                        ? 'Thank you. You can close this page.'
                                        : isLoggedIn
                                            // full reload so the app picks up the verified flag
                                            ? <Button type="primary" onClick={() => window.location.assign('/')}>Continue</Button>
                                            : <Link to="/">Go to login</Link>}
                                />
                            )}
                            {state === 'error' && (
                                <Result
                                    status="warning"
                                    title="Couldn't verify your email"
                                    subTitle={message}
                                    extra={isLoggedIn
                                        ? <Button onClick={() => window.location.assign('/')}>Back</Button>
                                        : <span>
                                            Nutritionists: <Link to="/">log in</Link> to get a new link.
                                            Patients: ask your nutritionist to send a new one.
                                        </span>}
                                />
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}
